<template>
  <div class="zoom-container">
    <zoom-slider-wrapper />
    <zoom-button-list/>
  </div>
</template>

<script>
  import ZoomButtonList from './ZoomButtonList';
  import ZoomSliderWrapper from './ZoomSliderWrapper';

  export default {
    name: 'ZoomContainer',
    components: { ZoomSliderWrapper, ZoomButtonList },
    props: {
      viewport: {
        type: Object,
        required: true
      },
      dependencies: {
        type: Array,
        required: true
      }
    },
    provide () {
      return {
        viewport: this.viewport,
        dependencies: this.dependencies
      };
    }
  };
</script>

<style scoped lang="scss">
.zoom-container {
  position: absolute;
  margin-left: 15px;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
}
</style>
